import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import {SaveFile, UploadFile} from '@/vue-dlb/models'
import appUtil from '@/vue-dlb/utils/app-util'
import config from '@/vue-caas/config/config.js';


import {
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";

const isDlbMybatis = config.isDlbMybatis;

const state = {
  codetables: [],
  codeGroupList: [],
  codeLinkedGroup: [],
  codeDataPool: [],
  allCodeDataPool:[],
  allCodeDataPoolSource: [],
  codeDataPoolSource: [],
  codeDataPoolFixed: [],
};

const getters = {
};

const actions = {
  codetables: async ({ commit }, searchItems) => {
    console.log("TTTTTT")
    let retSet = new ObjDataSet("codetables");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("codetables");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_CODE_LIST_MAN_CODE_CTG_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      // let obj = JSON.parse()
      commitRetDataSets(commit, res.data);
    });
  },
  codeGroupList: async ({ commit }, searchItems) => {
    let retSet = new ObjDataSet("codeGroupList");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("codeGroupList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_CODE_LIST_MAN_CODE_GRP_FN";    
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      // let obj = JSON.parse()
      commitRetDataSets(commit, res.data);
    });
  },
  codeLinkedGroup: async ({ commit }, searchItems) => {
    let retSet = new ObjDataSet("codeLinkedGroup");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("codeLinkedGroup");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_CODE_LIST_MAN_CODE_LNK_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  // 2021.4.26 203728 SPKA-80 Issue 42 change for out of memory
  codeDataPoolPaging: async ({ commit }, searchItems) => {
    let retSet = new ObjDataSet("codeDataPool");
    let retSet2 = new ObjDataSet("totalDataPool");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("codeDataPool");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DS02:EDP_CODE_LIST_MAN_CODE_ITM_FN|DS03:EDP_CODE_LIST_MAN_CODE_TTL_FN";
    trSet.suiParam = "USER_TIMEZONE"
    const reqdata = selectDataSetByDataSet(trSet);
    return await api.putData("UserDispatcherServlet", reqdata).then(res => {
      // commitRetDataSets(commit, res.data);
      let rtnData = {};
      let code = res.data.DataSets.find(e => e.DataSetName === 'codeDataPool');
      let total = res.data.DataSets.find(e => e.DataSetName === 'totalDataPool');
      rtnData.codeDataPool = code ? code.DataRows: [];
      rtnData.totalDataPool = total ? total.DataRows[0].TOTAL : 0;
      return rtnData;
    });
  },
  codeDataPool: async ({ commit }, searchItems) => {
    let retSet = new ObjDataSet("codeDataPool");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("codeDataPool");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_CODE_LIST_MAN_CODE_ITM_FN";
    trSet.suiParam = "USER_TIMEZONE"
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  allCodeDataPool: async ({ commit }, searchItems) => {
    let retSet = new ObjDataSet("allCodeDataPool");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("allCodeDataPool");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_CODE_LIST_MAN_CODE_ITM_FN";
    trSet.suiParam = "USER_TIMEZONE"
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  addCategory: async ({ commit }, payload) => {
    let insertMaster = payload[0];
    let insertData = payload[1];
    const retSet = new ObjDataSet("rtnPrcsNo");
    let condSet1 = new ObjDataSet("condSet1");
    let condSet2 = new ObjDataSet("condSet2");
    const trSet = new ObjTrSet("addCategory");
    condSet1 = appUtil.addDataHeader(insertMaster, condSet1);
    condSet2 = appUtil.addDataHeader(insertData, condSet2);
    trSet.AddDataSet("I", "DS01", condSet1);
    trSet.AddDataSet("I", "DS02", condSet2);
    trSet.AddDataSet("O", "DS03", retSet);
    trSet.tranID = "CodeTableManager";
    trSet.tranMethod = "addCategory";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  modifyCategoryName: async ({ commit }, paramItems) => {    
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("modifyCategoryName");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "CodeTableManager";
    trSet.tranMethod = "modifyCategoryName";
    const reqdata = callByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  modifyCategoryDetail: async ({ commit }, paramItems) => {    
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("modifyCategoryDetail");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "CodeTableManager";
    trSet.tranMethod = "modifyCategoryDetail";
    const reqdata = callByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deployCodeList: async ({ commit }, paramItems) => {    
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deployCodeList");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "CodeTableManager";
    trSet.tranMethod = "deployCodeList";
    const reqdata = callByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  saveCodeItems: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    let condSet2 = new ObjDataSet("condSet2");
    const trSet = new ObjTrSet("saveCodeItems");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("U", "DS02", condSet2);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "CodeTableManager";
      trSet.tranMethod = "saveCodeItems";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_CODE_UPD_MAN_CODE_ITM_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    console.log(reqdata);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteTable: async ({ commit }, searchItems) => {
    let retSet = new ObjDataSet("dataSet01");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("deleteTable");
    let reqdata = ''
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    if (isDlbMybatis) {
      trSet.tranID = "CodeTableManager";
      trSet.tranMethod = "deleteTable";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.AddDataSet("O", "DS02", retSet);
      trSet.tranID = "EDP_CODE_DEL_MAN_CODE_CTG_SP";
      reqdata = execSPByDataSet(trSet);
    }

    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },  
};

const mutations = {
  'SET_CODE_FILTER'(state, params) {

    let type = params.src.type;
    let search = params.src.search;
    // 2021.4.26 203728 SPKA-75 issue 42 code data pool
    let arrFilter = params.source ? params.source : state.codeDataPoolSource;
    if (search != undefined && search != '') {
      arrFilter = arrFilter.filter((item) => {
        return item[type].toLowerCase().includes(search.toLowerCase());
      });
    }

    type = params.target.type;
    search = params.target.search;
    if (search != undefined && search != '') {
      arrFilter = arrFilter.filter((item) => {
        return item[type].toLowerCase().includes(search.toLowerCase());
      });
    }
    state.codeDataPool = arrFilter;
  },
  'SET_STORE_CODE_TABLE_FILTER'(state, params) {
    console.log("state");
    console.log(state);
    if (state.setCnt == 1) {
      // state.codeDataPoolFixed = state.codeDataPool;
    }
    state.setCnt++;

    let CODE_GRP_CD = params.CODE_GRP_CD;
    let CODE_ITM_SRC_CD = params.CODE_ITM_SRC_CD;
    let CODE_ITM_TRG_CD = params.CODE_ITM_TRG_CD;
    // 2021.4.27 203728 SPKA-75 issue 42 code data pool
    let arrFilter = params.source ? params.source : state.allCodeDataPoolSource;
    if (CODE_GRP_CD != undefined && CODE_GRP_CD != '') {
      arrFilter = arrFilter.filter((item) => {
        for (const prop in item) {
          if (prop =="CODE_GRP_CD") {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = CODE_GRP_CD.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = CODE_GRP_CD.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        }
      });
    }
    if (CODE_ITM_SRC_CD != undefined && CODE_ITM_SRC_CD != '') {
      arrFilter = arrFilter.filter((item) => {
        for (const prop in item) {
          if (prop =="CODE_ITM_SRC_CD") {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = CODE_ITM_SRC_CD.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = CODE_ITM_SRC_CD.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        }
      });
    }
    if (CODE_ITM_TRG_CD != undefined && CODE_ITM_TRG_CD != '') {
      arrFilter = arrFilter.filter((item) => {
        for (const prop in item) {
          if (prop =="CODE_ITM_TRG_CD") {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = CODE_ITM_TRG_CD.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = CODE_ITM_TRG_CD.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        }
      });
    }
    state.allCodeDataPool = arrFilter;
  },
  codetables (state, datarows) {
    state.codetables = datarows;
  },
  codeLinkedGroup (state, datarows) {
    state.codeLinkedGroup = datarows;
  },
  codeDataPool (state, datarows) {
    state.codeDataPool = datarows;
    state.codeDataPoolSource = datarows;
  },
  allCodeDataPool (state, datarows) {
    state.allCodeDataPool = datarows;
    state.allCodeDataPoolSource = datarows;
  },
  codeGroupList (state, datarows) {
    state.codeGroupList = datarows;
  },
  foldList (state, datarows) {
    state.foldList = datarows;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
